/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetKeywordsResponseAllOf,
    GetKeywordsResponseAllOfFromJSON,
    GetKeywordsResponseAllOfFromJSONTyped,
    GetKeywordsResponseAllOfToJSON,
} from './GetKeywordsResponseAllOf';
import {
    Keyword,
    KeywordFromJSON,
    KeywordFromJSONTyped,
    KeywordToJSON,
} from './Keyword';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * 
 * @export
 * @interface GetKeywordsResponse
 */
export interface GetKeywordsResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetKeywordsResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetKeywordsResponse
     */
    message: string;
    /**
     * 
     * @type {Array<Keyword>}
     * @memberof GetKeywordsResponse
     */
    data: Array<Keyword>;
}

export function GetKeywordsResponseFromJSON(json: any): GetKeywordsResponse {
    return GetKeywordsResponseFromJSONTyped(json, false);
}

export function GetKeywordsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetKeywordsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(KeywordFromJSON)),
    };
}

export function GetKeywordsResponseToJSON(value?: GetKeywordsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ((value.data as Array<any>).map(KeywordToJSON)),
    };
}

